import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Features from './components/Features';
import Documentation from './components/Documentation';
import Usage from './components/Usage';
import License from './components/License';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="bg-[#0a0a0a] min-h-screen">
      <Navbar />
      <Hero />
      <About />
      <Features />
      <Documentation />
      <Usage />
      <License />
      <Footer />
    </div>
  );
}
